import styled from 'styled-components';
import { colors, fontSizes, fontWeights, spacing } from 'syf-component-library/defaultTheme';
import { Inset } from 'syf-component-library/ui/spacing';
import query from 'syf-component-library/const/mediaQueries';
export const CalendarContainer = styled(Inset) `
  display: flex;
  justify-content: center;
  border-bottom: solid 1px ${colors.lightGrey};
  width: 100%;
`;
export const CalendarLegendContainer = styled(Inset) `
  margin: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  @media ${query.lessThanSmall} {
    align-items: flex-start;
    flex-flow: column;
    width: 329px;
    gap: ${spacing.medium}px;
    padding-left: ${spacing.large}px;
    padding-right: ${spacing.large}px;
  }
`;
export const CalendarLegendItem = styled.div `
  display: flex;
  align-items: center;
  font-weight: ${fontWeights.semiBold};
  font-size: 14px;
`;
const BaseCalendarLegendIcon = styled.div `
  min-width: 16px;
  height: 16px;
  width: 16px;
  border-radius: 3px;
  margin-right: 8px;
`;
export const CurrentCalendarLegendIcon = styled(BaseCalendarLegendIcon) `
  border: solid 1px ${colors.cyanBlue};
`;
export const SelectedCalendarLegendIcon = styled(BaseCalendarLegendIcon) `
  background-color: ${colors.cyanBlue};
`;
export const CalendarGrid = styled(Inset) `
  display: grid;
  grid-template-columns: repeat(7, 0fr);
  grid-template-rows: repeat(4, 0fr);
  @media ${query.lessThanSmall} {
    padding: 0 ${spacing.medium}px;
  }
`;
export const GridItemContainer = styled.div `
  padding: 2px;
`;
export const NonSelectable = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 40px;
  border-radius: 5px;
  color: ${colors.silver};
  font-size: ${fontSizes.root}px;
`;
export const CurrentDueDay = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 40px;
  border-radius: 5px;
  color: ${colors.cyanBlue};
  border: solid 2px ${colors.cyanBlue};
  font-size: ${fontSizes.root}px;
  font-weight: ${fontWeights.bold};
`;
export const Selected = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 40px;
  border-radius: 5px;
  font-size: 16px;
  color: ${colors.white};
  background-color: ${colors.cyanBlue};
  font-weight: ${fontWeights.bold};
`;
export const Selectable = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 40px;
  border-radius: 5px;
  font-size: ${fontSizes.root}px;
  color: ${colors.black};
  cursor: pointer;
  background-color: ${colors.white};
  &:hover {
    color: ${colors.white};
    background-color: ${colors.cyanBlue};
    font-weight: ${fontWeights.bold};
  }
`;
